import React, {Component} from "react";
import {withNamespaces} from "react-i18next";
import {networkDeviceService} from "../../../../services/network-device.service";
import {Alert, ListGroup} from "react-bootstrap";
import DeviceInfoColumn from "../../../../components/DeviceInfoColumn";
import {formatterHelper} from "../../../../helpers/formatter-helper";
import {toastr} from "react-redux-toastr";

class NetworkDeviceUpdaterForm extends Component {

    state = {
        versionIsChanges: false,
        selectedVersion: null,
        selectedVersionWithoutExt: null,
        selectedId: [],
        selectAll: false,
        networkDeviceList: [],
        softwareVersions: [],
        filter: '',
    }

    componentDidMount() {
        networkDeviceService.getList()
            .then((networkDevices) => {
                this.setState({
                    ...this.state,
                    networkDeviceList: networkDevices
                });
            });

        networkDeviceService.getSoftwareVersions()
            .then((res) => {
                this.setState({
                    ...this.state,
                    softwareVersions: res
                });
            });
    }

    handleOnChangeVersion = (e) => {
        const selectedVer = e.target.value;

        this.setState({
            ...this.state,
            versionIsChanges: selectedVer !== 'none',
            selectedVersion: selectedVer !== 'none' ? e.target.value : null,
            selectedVersionWithoutExt: selectedVer !== 'none' ? formatterHelper.removeExtension(e.target.value) : null,
            selectedId: []
        });
    }

    hasCheck = (networkDeviceId) => {
        const { selectedId } = this.state;
        return selectedId.includes(networkDeviceId);
    }

    handleSelectAll = (e) => {
        const { networkDeviceList, selectAll, selectedVersionWithoutExt } = this.state;
        const selectedArray = [];
        networkDeviceList.forEach((device, idx) => {
            if(device.deviceType.label === "PC") {
                if(!selectAll && device.isOnline === true && device.hiLightSoftwareVersion !== selectedVersionWithoutExt ) {
                    selectedArray.push(device.id)
                }
            }
        })

        this.setState({
            ...this.state,
            selectAll: !this.state.selectAll,
            selectedId: selectedArray
        });
    }

    handleSelectDevice = (e, deviceId) => {
        const { selectedId } = this.state;
        const selectedArray = [...selectedId];

        if(this.hasCheck(deviceId))
        {
            const index = selectedArray.indexOf(deviceId);
            if (index > -1) {
                selectedArray.splice(index, 1);
            }
        }
        else
            selectedArray.push(deviceId);

        this.setState({
            ...this.state,
            selectedId: selectedArray
        });
    }

    handleClickUpdateButton = (e) => {
        e.preventDefault();
        const { selectedId, selectedVersion } = this.state;
        const { t, closeModal } = this.props;

        networkDeviceService.updateSoftForDevices(selectedId, selectedVersion)
            .then(
                () => {
                    toastr.success(t('global-updater'), t('success-updater-msg'))
                    closeModal();
                },
                (error) => {
                    toastr.error(t('global-updater'), t('error-updater-msg'))
                }
            )
    }

    render() {
        const { t } = this.props;
        const { networkDeviceList, softwareVersions, selectedVersion, versionIsChanges, selectedVersionWithoutExt, selectedId } = this.state;
        return (
            <React.Fragment>
                <p>{t('updater-info')}</p>

                <div className="jumbotron">
                    <p><small>{t('switch-version-info')})</small></p>
                    <label>{ t('update-hilight-software') }</label>
                    <select
                        className="form-control"
                        value={selectedVersion || "none"}
                        onChange={this.handleOnChangeVersion}
                    >
                        <option value={"none"}>{ t('no-version') }</option>
                        { softwareVersions?.map((item, idx) => {
                            return (<option key={idx} value={item}>{ item }</option>)
                        })}
                    </select>
                </div>


                { versionIsChanges && selectedVersion !== "none"  ? (
                    <React.Fragment>
                        {  networkDeviceList.filter((x) => x.isOnline === true).length === 0 ? (
                            <Alert variant={"info"}>
                                <p className="text-center">{t('updater-no-devices-info')}</p>
                            </Alert>
                        ) : (
                            <button className="btn btn-primary my-2" onClick={(e) => this.handleSelectAll(e)}>
                                { t('select-all') }
                            </button>
                        ) }

                        <ListGroup>
                            { networkDeviceList?.map((item, idx) => {
                                if(item.deviceType.label !== "PC" || item.hiLightSoftwareVersion === selectedVersionWithoutExt || !item.isOnline) {
                                    return null;
                                }
                                return (
                                    <ListGroup.Item key={idx}>
                                        <div className="item-content row align-items-center">
                                            <div className="col-1">
                                                <input
                                                    type="checkbox"
                                                    className="form-check"
                                                    name="select"
                                                    checked={this.hasCheck(item.id)}
                                                    onChange={(e) => this.handleSelectDevice(e, item.id)}
                                                />
                                            </div>
                                            <div className="col-3">
                                                <DeviceInfoColumn networkDevice={item} />
                                            </div>
                                            <div className="col-8">
                                                <label>{ t('current-version') }</label>
                                                <input
                                                    className="form-control"
                                                    disabled={true}
                                                    value={item.hiLightSoftwareVersion || t('no-version') }
                                                />
                                            </div>
                                        </div>
                                    </ListGroup.Item>
                                );
                            }) }
                        </ListGroup>

                        { selectedVersion && selectedVersion !== "none" && selectedId.length !== 0 ? (
                            <div className="py-2">
                                <Alert variant={"warning"}>
                                    { t('info-update-warning') }
                                </Alert>
                            </div>
                        ) : (<React.Fragment/>) }

                        <button className="btn btn-outline-success mt-3" disabled={selectedId.length === 0 && selectedVersion !== "none"} onClick={this.handleClickUpdateButton}>
                            { t('btn-update') }
                        </button>

                    </React.Fragment>
                ) : (
                    <React.Fragment/>
                ) }
            </React.Fragment>
        )
    }
}
export default withNamespaces()(NetworkDeviceUpdaterForm);